export const agentNames: Record<string, string> = {
  interactive_planner_agent: "Research planning in progress",
  research_pipeline: "Beginning research",
  section_planner: "Structuring report sections",
  section_researcher: "Researching documents",
  research_evaluator: "Evaluating research quality",
  enhanced_search_executor: "Deepening document analysis",
  report_composer_with_citations: "Finalizing report with citations",
  combined_report_composer_with_citations:
    "Finalizing comprehensive report with citations",
  db_ds_multiagent_dispatcher: "Analyzing the data",
  db_ds_multiagent_planner: "Data analysis in progress",
  text_analytics_agent: "Identifying text analysis tasks",
  analytics_report_composer: "Composing all insights together",
  synthesio_agent_dispatcher: "Syncing insights from Synthesio",
};
